import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminGuests from "./AdminGuests";
import AdminGuest from "./AdminGuest";
import { useSelector } from "react-redux";
import { ApplicationState } from "store";
import { isSuperUser } from "shared/api/isSuperUser";
import { UseLivlyLeaseUser } from "shared/api/LivlyUserProvider";

export default function Guests() {
  const [search, setSearch] = React.useState("");
  const user = UseLivlyLeaseUser();
  const isSuperUserPermission = isSuperUser(user);

  if (!isSuperUserPermission) {
    return (
      <div style={{ marginTop: 24, fontWeight: 500, color: "red" }}>
        Access Denied: You do not have permission to access this page
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={<AdminGuests search={search} setSearch={setSearch} />}
      />
      <Route path="/:guestId/*" element={<AdminGuest />} />
    </Routes>
  );
}
